import placeOrder from './placeOrder';

export default placeOrder;
